
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "10 stratégies pour le ciblage de votre campagne Facebook Ads",
    description:
      "Explorez des stratégies de ciblage puissantes pour optimiser vos campagnes Facebook Ads, maximiser leur impact et atteindre votre audience avec précision.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
